import { render, staticRenderFns } from "./tabsCustom.vue?vue&type=template&id=05dc5e98&scoped=true&"
import script from "./tabsCustom.vue?vue&type=script&lang=js&"
export * from "./tabsCustom.vue?vue&type=script&lang=js&"
import style0 from "./tabsCustom.vue?vue&type=style&index=0&id=05dc5e98&prod&lang=scss&scoped=true&"
import style1 from "./tabsCustom.vue?vue&type=style&index=1&id=05dc5e98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc5e98",
  null
  
)

export default component.exports